interface IScopeProps {
  scope: {
    roofing: string;
    plumbing: string;
    electrical: string;
    heatAndAir: string;
    structural: string;
    painting: string;
  };
}
export default function Scope({ scope }: IScopeProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Scope
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6'>
          <div className='space-y-6'>
            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Roofing</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.roofing ? 'Yes' : 'No'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Plumbing</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.plumbing ? 'Yes' : 'No'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Electrical</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.electrical ? 'Yes' : 'No'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Heat & Air</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.heatAndAir ? 'Yes' : 'No'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Structural</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.structural ? 'Yes' : 'No'}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Painting</dt>
                <dd className='mt-1 text-sm capitalize text-gray-900'>{scope?.painting ? 'Yes' : 'No'}</dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
